module.exports = __webpack_public_path__ + "static/meditation-04fe04782f732f86d5f66168490c52e9.png";